// extracted by mini-css-extract-plugin
export default {"deliverySection":"ShippingDelivery_deliverySection__ThmV5","deliverySectionTitle":"ShippingDelivery_deliverySectionTitle__Q3boa"};